/* css-after-load.js — 비필수 스타일시트를 ★window load 뒤★ 에 붙인다 (defer · 문서당 1회)
 *
 * 서버(src/lib/css-after-load.ts)는 그 스타일시트 자리에 <link> 대신 표식
 * <noscript data-ins-css-after-load="주소"> 를 둔다. JS 가 켜진 브라우저는 noscript 안을 받지 않으므로
 * ★load 전에는 요청 자체가 없다★ — media="print" 스왑과 달리 WebKit 이 그 시트를 load 이벤트의
 * 관문으로 기다리지 않는다(iOS RUM: DOMContentLoaded→load ~400ms 의 원인).
 * 이 파일은 load 가 지나면 표식 ★바로 앞★ 에 <link rel=stylesheet> 를 끼운다 — 요소 순서가
 * 캐스케이드를 정하므로 종전 <link> 가 있던 자리와 같은 순서가 된다.
 *
 * 붙이는 때 — 셋 중 먼저 오는 것:
 *   ① load 뒤 한 박자(setTimeout 0) · 이미 load 가 지났으면 즉시
 *   ② load 전의 첫 사용자 입력(pointerdown·touchstart·keydown) — 시트·다이얼로그를 여는 탭이
 *      스타일 없는 창을 보지 않게 그 순간 붙인다
 *   ③ 백스톱 — DOMContentLoaded 뒤 4초(load 가 느린 자원에 오래 묶인 날, 스크롤 아래 내용 보호)
 * 조각 전환(ins:fragnav-done)으로 새 표식이 들어오면 그때 다시 훑는다. 같은 주소의 시트가 이미
 * 문서에 있으면 붙이지 않는다(이중 주입 0).
 * ⚠️ 보간 문법 금지 — 정적 파일이라 그대로 사용자에게 나간다.
 * 계약: tests/contracts/css-after-load.test.ts
 */
(function(){
  var W = window, D = document;
  if (W.__insCssAfterLoad) return;
  var ATTR = 'data-ins-css-after-load';
  var EARLY = ['pointerdown', 'touchstart', 'keydown'];
  var armed = 0;

  /* noscript 안의 폴백 <link> 는 세지 않는다 — JS 가 켜진 브라우저에선 원래 글자일 뿐이지만,
     파서가 그것을 원소로 만든 환경에서도 「이미 있다」로 오판해 시트를 빠뜨리지 않게. */
  function inNoscript(n){
    for (var p = n.parentNode; p; p = p.parentNode) if (String(p.tagName || '').toLowerCase() === 'noscript') return true;
    return false;
  }
  function present(href){
    var ls = D.getElementsByTagName('link');
    for (var i = 0; i < ls.length; i++) {
      if (ls[i].getAttribute('href') === href && /(^|\s)stylesheet(\s|$)/i.test(ls[i].getAttribute('rel') || '') && !inNoscript(ls[i])) return true;
    }
    return false;
  }
  function scan(){
    var ms = D.querySelectorAll('noscript[' + ATTR + ']');
    for (var i = 0; i < ms.length; i++) {
      var m = ms[i], href = m.getAttribute(ATTR);
      m.removeAttribute(ATTR);
      if (!href || present(href) || !m.parentNode) continue;
      var l = D.createElement('link');
      l.setAttribute('rel', 'stylesheet');
      l.setAttribute('href', href);
      m.parentNode.insertBefore(l, m);
    }
  }
  function arm(){
    if (armed) return;
    armed = 1;
    for (var i = 0; i < EARLY.length; i++) {
      try { W.removeEventListener(EARLY[i], arm, true); } catch (x) {}
    }
    scan();
  }
  for (var k = 0; k < EARLY.length; k++) {
    try { W.addEventListener(EARLY[k], arm, { capture: true, passive: true }); }
    catch (x) { W.addEventListener(EARLY[k], arm, true); }
  }
  W.addEventListener('ins:fragnav-done', function(){ if (armed) scan(); });
  W.__insCssAfterLoad = { scan: scan, arm: arm };

  if (D.readyState === 'complete') arm();
  else {
    W.addEventListener('load', function(){ W.setTimeout(arm, 0); });
    D.addEventListener('DOMContentLoaded', function(){ W.setTimeout(arm, 4000); });
  }
})();
